import { Modal } from "components";
import { OrderableList } from "components/Tables";
import { Message } from "semantic-ui-react";
import React, { useState } from "react";
import { PlusButton } from "components/Atoms/PlusMinusButton";
import { DropdownRow, NoChoiceMadeDropdownRow } from "./DropdownRow";
import { ButtonPrimary } from "components/Atoms/Button";

interface DropdownOptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (newOptions: string[], defaultOption: string | null) => void;
  defaultOption: string | null;
  displayWarning: boolean;
  options: string[];
}

export const DropdownOptionsModal = (props: DropdownOptionsModalProps) => {
  const [options, setOptions] = useState<string[]>(props.options);
  const [defaultOption, setDefaultOption] = useState<string | null>(props.defaultOption || null);

  const onOrderChanged = (newOptions: string[]) => {
    setOptions(newOptions);
  }

  const onDelete = (option: string) => {
    setOptions(options.filter(o => o !== option));
  }

  const onModify = (oldOption: string, newOption: string) => {
    setOptions(options.map(o => o === oldOption ? newOption : o));
  }

  const onAdd = () => {
    const newOptions = [...options, `${RESX.Status.LblOption} ${options.length + 1}`];
    setOptions(newOptions);
  }

  return <Modal
    isOpen={props.isOpen}
    title={RESX.Status.Options}
    width="small"
    height={500}
    handleClose={props.onClose}
  >
    <div className="flex-column gap-larger grow1" style={{ minHeight: "inherit" }}>
      <div className="grow1" style={{ minHeight: 0 }}>
        <div className="scrollbox-auto" style={{ height: "100%" }}>
          <NoChoiceMadeDropdownRow
            defaultOption={defaultOption}
            onSetAsDefault={() => setDefaultOption(null)}
          />
          <OrderableList
            listId="dropdown-options"
            items={options}
            getKey={o => o}
            render={option => <DropdownRow
              option={option}
              defaultOption={defaultOption}
              onChangeLabel={newOption => onModify(option, newOption)}
              onSetAsDefault={() => setDefaultOption(option)}
            />}
            onOrderChanged={onOrderChanged}
            onDelete={onDelete}
          />
        </div>
      </div>

      {props.displayWarning && <Message style={{ minHeight: 56 }} color="red">
        {RESX.FreeField.WarningChangeDropdown}
      </Message>}

      <div className="flex justify-space-between">
        <PlusButton
          onClick={onAdd}
        >
          {RESX.Buttons.Add}
        </PlusButton>
        <ButtonPrimary
          onClick={() => props.onSave(options, defaultOption)}
          label={RESX.Buttons.btnSave}
        />
      </div>
    </div>
  </Modal>
}